<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<i class="el-icon-back backIcon" @click='goBack'></i>
				<span class="topTitle">知识库详情</span>
			</div>

			<h3>基础信息</h3>
			<div class="flex linebg"><span class="title">知识库名称：</span>{{addBody.name}}</div>
			<div class="flex linebg"><span class="title">知识库简介：</span>{{addBody.desc}}</div>
			<div class="flex linebg"><span class="title">创建时间：</span>{{addBody.create_time}}</div>
			<div class="flex linebg"><span class="title">是否应用到对话模块：</span>{{addBody.is_chat==1?'否':'是'}}</div>
			<el-tabs type="border-card" @tab-click="tabChange">
				<el-tab-pane label="文档">
					<div style="display: flex;align-items: flex-end;justify-content: flex-end;margin-bottom: 20px;">
						<!-- <div class="dankal-image-upload">
							<el-button type="primary" @click="onSelected">
								<span>添加数据</span>
							</el-button>
							<input ref="input" max="1" type="file" id="file" style="display:none;" :accept="accept"
								@change="onFileChanged">
						</div> -->
						<div class="dankal-image-upload">
							<el-button type="primary" @click="dialogVisible = !dialogVisible">
								<span>添加数据</span>
							</el-button>
						</div>
					</div>

					<el-table :data="dataSetFiles" stripe style="width: 100%">
						<el-table-column prop="file_name" label="文件名称">
						</el-table-column>
						<el-table-column prop="key_num" label="字数量">
						</el-table-column>
						<el-table-column prop="create_time" label="添加时间">
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="180">
							<template slot-scope="scope">
								<div style="display: flex;align-items: center;">
									<span class="operation-item" style="cursor: pointer;"
										@click="openViewFile(scope.row)">
										查看</span>
									<span class="operation-item delete" style="margin-left: 20px;cursor: pointer;"
										@click="network().deleteDataSetFile(scope.row.uuid)">
										删除</span>
								</div>
							</template>
						</el-table-column>
					</el-table>

				</el-tab-pane>
				<el-tab-pane label="语料管理">

					<el-table :data="yuliaoTables" stripe style="width: 100%">
						<el-table-column prop="title" label="语料">
						</el-table-column>
						<el-table-column prop="rate" label="相似度">
							<template slot-scope="scope">
								{{scope.row.rate*100}}%
							</template>
						</el-table-column>
						<el-table-column prop="create_time" label="添加时间">
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="180">
							<template slot-scope="scope">
								<div style="display: flex;align-items: center;">
									<span class="operation-item" style="cursor: pointer;"
										@click="editAdminClick(scope.row)">
										编辑</span>
									<span class="operation-item delete" style="margin-left: 20px;cursor: pointer;"
										@click="network().deleteDataSetYuliao(scope.row.id)">
										删除</span>
								</div>
							</template>
						</el-table-column>
					</el-table>
					
					
					<common-pagination :total="total1" :page_size="page_size1" :page_index="page_index1"
						@page-change="handlePageChange1"></common-pagination>

				</el-tab-pane>
			</el-tabs>
		</el-card>

		<el-dialog title="编辑语料" :visible.sync="dialogShow" width="30%">
			<el-input v-model="title" placeholder="请输入语料"></el-input>

			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="network().confirmModuleItem()">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="添加数据" :visible.sync="dialogVisible" width="70%">

			<div style="width: 50%;margin-left: 25%;margin-bottom: 30px;">
				<el-steps :active="nextNum-1" finish-status="success">
					<el-step title="导入数据"></el-step>
					<el-step title="数据处理"></el-step>
				</el-steps>
			</div>

			<div v-if="nextNum == 1">
				<div class="tabs">
					<div :class="file_item.file_tag==1?'tabd':'tab'" @click="file_item.file_tag=1">
						<i class="el-icon-document"></i><span style="margin-left: 8px;">文本格式</span>
					</div>
					<div :class="file_item.file_tag==2?'tabd':'tab'" style="margin-left: 20px;"
						@click="file_item.file_tag=2">
						<i class="el-icon-document-add"></i><span style="margin-left: 8px;">表格格式</span>
					</div>
				</div>
				<el-card class="box-card">
					<div slot="header" class="clearfix1">
						<div v-if="file_item.file_tag==1">支持上传Txt、Doc、Docx、PDF格式文件</div>
						<div v-if="file_item.file_tag==2">支持上传Excel或CSV格式文档，文件大小限制20MB以内</div>
						<div v-if="file_item.file_tag==1">
							<el-upload accept='.doc,.docx,.txt,.pdf' class="" :limit='1' :show-file-list='false'
								:action="urlDomain+'/common/UploadFile'" :on-remove="handleRemove" multiple
								:onSuccess="onSuccess">
								<el-button style=" padding: 3px 0" type="text" class="btnsc">上传文件</el-button>
							</el-upload>
						</div>
						<div class="dankal-image-upload" v-if="file_item.file_tag==2">
							<el-button type="primary" @click="onSelected">
								<span>上传文件</span>
							</el-button>
							<input ref="input" max="1" type="file" id="file" style="display:none;" :accept="accept"
								@change="onFileChanged">
						</div>
					</div>
					<div class="tabtitles">
						<div class="titles ft t-l">文件名称</div>
						<div class="titles ft t-c">文件大小</div>
						<div class="titles ft t-r">操作</div>
					</div>
					<div v-if="file_item.file_tag==1" v-for="(item,index) in fileList" :key="index" class="text item"
						style="margin-top: 30px;">
						<div class="tabtitles">
							<div class="titles t-l">{{item.name||item.file_name}}</div>
							<div class="titles t-c">{{(item.size||item.key_num)/1000}}KB</div>
							<div class="titles t-r" style="text-align: right;">
								<i class="el-icon-delete" style="text-align: right;" @click="deleteFile(index)"></i>
							</div>
						</div>
					</div>
					<div v-if="file_item.file_tag==2" v-for="(item,index) in excelList" :key="index" class="text item"
						style="margin-top: 30px;">
						<div class="tabtitles">
							<div class="titles t-l">{{item.name||item.file_name}}</div>
							<div class="titles t-c">{{(item.size||item.key_num)/1000}}KB</div>
							<div class="titles t-r" style="text-align: right;">
								<i class="el-icon-delete" style="text-align: right;"
									@click="deleteExcelFile(index)"></i>
							</div>
						</div>
					</div>
				</el-card>
			</div>

			<div v-if="nextNum == 2 && file_item.file_tag==2">
				<el-form ref="addBody" :model="addBody" label-position='top'>

					<el-card class="box-card">
						<el-row>
							<el-col :span="8">
								<div style="margin-bottom: 10px;">
									数据表
								</div>
								<el-select style="width: 100%;" v-model="excel_item.form_uuid" placeholder="请选择数据表">
									<el-option v-for="item in excelDatas" :key="item.uuid" :label="item.sheet_name"
										:value="item.uuid">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="8">
								<div style="margin-bottom: 10px;margin-left: 5%">
									表头行
								</div>
								<el-select style="width: 90%;margin-left: 5%;" v-model="excel_item.title_num"
									placeholder="请选择表头行">
									<el-option v-for="(item,index) in 99" :key="index+1" :label="index+1"
										:value="index+1">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="8">
								<div style="margin-bottom: 10px;">
									数据起始行
								</div>
								<el-select style="width: 100%;" v-model="excel_item.data_num" placeholder="请选择数据起始行">
									<el-option v-for="(item,index) in 99" :key="index+1" :label="index+1"
										:value="index+1">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="24">
								<div style="margin-top: 20px;text-align: right;">
									<el-button type="primary" @click="network().viewExcelData()">查看预览</el-button>
								</div>
							</el-col>
						</el-row>

						<el-table :data="tableData" style="width: 100%">
							<el-table-column v-for="(title, index) in tableTitle" :key="index" :label="title"
								:prop="getPropName(index)">
							</el-table-column>
						</el-table>

						<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
							@page-change="handlePageChange"></common-pagination>
					</el-card>

				</el-form>
			</div>

			<div v-if="nextNum == 2 && file_item.file_tag==1">
				<el-form ref="addBody" :model="addBody" label-position='top'>

					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<img src="../../assets/images/yxz.png" v-if="data_type_show==1" @click="selectDataType(1)"
								style="width: 25px;height: 25px;margin-right: 5px;" />
							<img src="../../assets/images/wxz.png" v-else @click="selectDataType(1)"
								style="width: 25px;height: 25px;margin-right: 5px;" />
							<span class="title">自动分段与清洗</span>
						</div>
						<div class="desc">自动分段与预处理规则</div>
					</el-card>

					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<img src="../../assets/images/yxz.png" v-if="data_type_show==2" @click="selectDataType(2)"
								style="width: 25px;height: 25px;margin-right: 5px;" />
							<img src="../../assets/images/wxz.png" v-else @click="selectDataType(2)"
								style="width: 25px;height: 25px;margin-right: 5px;" />
							<span class="title">自定义</span>
						</div>
						<div class="desc">自定义分段规则，分段长度及预处理规则</div>

						<div class="subtitle">分段标识符</div>
						<el-select v-model="file_item.data_type_item" :multiple='true' style="width: 100%;"
							placeholder="请选择分段标识符">
							<el-option v-for="item in lmList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>

						<div class="subtitle">分段最大长度</div>
						<el-input v-model="addBody.max_length" type="number" placeholder="请输入分段最大长度"></el-input>

						<div style="margin-top: 30px;margin-bottom: 20px;" class="clearfix">
							<span class="title">文本预处理规则</span>
						</div>
						<div style="display: flex;flex-direction: column;">
							<el-checkbox v-model="checked">替换掉连续的空格、换行符和制表符</el-checkbox>
							<el-checkbox v-model="checked1" style="margin-top: 10px;">删除所有 URL 和电子邮箱地址</el-checkbox>
						</div>
					</el-card>

				</el-form>
			</div>
			<span slot="footer" class="dialog-footer" v-if="nextNum==1">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="toxlData('addBody',2)">下一步</el-button>
			</span>
			<span slot="footer" class="dialog-footer" v-if="nextNum==2">
				<div class="dialog-footer" style="margin-top: 25px;">
					<el-button @click="toxlData('addBody',1)">上一步</el-button>
					<el-button type="primary" @click="network().wordNextClick()">开始导入</el-button>
				</div>
			</span>

		</el-dialog>
	</div>
</template>

<script>
	import CommonPagination from "@/components/CommonPagination";
	import {
		uploadImgFile,
		qiniuInfo
	} from '@/api/common';
	import {
		getDataSetExcelInfo,
		addDataSetFile,
		addDataSetExcel,
		getDataSetExcel,
		updateCmsDataSet,
		addCmsDataSet,
		getDataSetDetail,
		getDataSetFile,
		addTableDataSetFile,
		deleteDataSetFile,
		getDataSetYuliao,
		editTableDataSetYuliao,
		deleteDataSetYuliao,
	} from "@/api/area-manage"
	import {
		imgDomain
	} from '@/configs/env';
	import {
		urlDomain
	} from '@/configs/baseUrl';
	import ImageUpload from "@/components/ImageUpload"
	export default {
		components: {
			ImageUpload,
			CommonPagination
		},
		data() {
			return {
				checked: false,
				checked1: false,
				dialogVisible: false,
				dialogShow: false,
				accept: '.xlsx, .xls, .csv',
				urlDomain,
				imgDomain,
				formLabelWidth: '120px',
				addBody: {},
				yuliaos: [],
				dataSetFiles: [],
				yuliaoTables: [],
				currentItem: '',
				title: '',
				nextNum: 1,
				file_item: {
					file_tag: 1, //1文本，2表格类型
					data_type: 1, //1自动分段，2自定义
					data_type_item: [], //1:多选/换行、 2:2 个换行、3:中文句号、4:中文叹号、5:中文问号、6:英文句号、7:英文叹号、8:英文问号
					file_name: '',
					file_type: '',
					file_url: '',
					excel_item: ''
				},
				excel_item: {
					form_uuid: '',
					title_num: '',
					data_num: '',
				},
				images: [],
				roleUuid: "",
				lmList: [{
					id: 3,
					name: '中文句号'
				}, {
					id: 4,
					name: '中文叹号'
				}, {
					id: 5,
					name: '中文问号'
				}, {
					id: 6,
					name: '英文句号'
				}, {
					id: 7,
					name: '英文叹号'
				}, {
					id: 8,
					name: '英文问号'
				}],
				fileList: [],
				excelList: [],
				excelDatas: [],
				page_index: 1,
				page_size: 10,
				tableUUID: '',
				excelTableDatas: '',
				tableData: [],
				total: 0,
				data_type_show: 0,
				total1:0,
				page_index1:1,
				page_size1: 10,
			}
		},
		computed: {
			tableTitle() {
				return this.excelTableDatas ? this.excelTableDatas.title : [];
			}
		},
		mounted() {
			if (this.$route.query.uuid) {
				this.addBody.uuid = this.$route.query.uuid
				this.network().getDataSetDetail()
				this.network().getDataSetFile(this.addBody.uuid)
				this.network().getDataSetYuliao(this.addBody.uuid)
			}
		},
		methods: {
			handlePageChange(e) {
				this.page_index = e
				this.network().viewExcelData()
			},
			handlePageChange1(e) {
				this.page_index1 = e
				this.network().getDataSetYuliao(this.addBody.uuid)
			},
			tabChange(e) {
				if (e.label == '文档') {
					this.network().getDataSetFile(this.addBody.uuid)
				} else {
					this.network().getDataSetYuliao(this.addBody.uuid)
				}
			},
			handleClose() {
				this.currentItem = ''
				this.title = ''
				this.dialogShow = false
			},
			editAdminClick(item) {
				this.currentItem = item
				this.title = item.title
				this.dialogShow = true
			},
			openViewFile(item) {
				window.open('https://view.xdocin.com/view?src=' + imgDomain + item.file_url)
			},
			goBack() {
				this.$router.go(-1)
			},
			uploadFile() {
				if (!this.addBody.content) {
					return this.$message.error('请输入人物设定')
				}
				this.dialogVisible = true
			},
			selectDataType(e) {
				this.file_item.data_type = e
				this.data_type_show = e
			},
			getPropName(index) {
				// 返回对应的属性名称
				return this.excelTableDatas ? this.excelTableDatas.title[index] : '';
			},
			uuid() {
				var s = [];
				var hexDigits = "0123456789abcdef";
				for (var i = 0; i < 36; i++) {
					s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
				}
				s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
				s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
				s[8] = s[13] = s[18] = s[23] = "-";
				var uuid = s.join("");
				return uuid;
			},
			handleRemove(file, fileList) {
				this.fileList = fileList
			},
			deleteFile(index) {
				this.fileList.splice(index, 1)
			},
			onSelected() {
				this.$refs.input.click();
			},
			//excel
			onFileChanged(event) {
				const file = event.target.files[0];
				this.excelList = []
				this.network().addDataSetExcel(file)
			},
			deleteExcelFile(index) {
				this.excelList.splice(index, 1)
			},
			//文本
			onSuccess(response, file, fileList) {
				this.file_item.file_name = file.name
				this.file_item.file_type = file.name.split('.')[1]
				this.file_item.file_url = response.result
				this.file_item.file_tag = 1
				this.file_item.file_size = file.size
				this.fileList = fileList
			},

			goBack() {
				this.$router.go(-1)
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			toxlData(formName, nextNum) {
				if (nextNum == 2) {
					if (this.file_item.file_tag == 1 && this.fileList.length == 0) {
						return this.$message.error('请上传文件')
					}
					if (this.file_item.file_tag == 2 && this.excelList.length == 0) {
						return this.$message.error('请上传文件')
					}
				}
				this.nextNum = nextNum
			},
			editUser(formName, nextNum) {
				if (this.isEdit) {
					this.network().updateRoleEmployee()
				} else {
					this.network().regionsave()
				}
			},
			network() {
				return {
					deleteDataSetFile: async (uuid) => {
						const {
							status,
							data
						} = await deleteDataSetFile({
							uuid: uuid
						})
						this.$message.success('删除成功')
						this.network().getDataSetFile(this.addBody.uuid)
					},
					addDataSetExcel: async (file) => {
						const formData = new FormData();
						formData.append("file", file);
						const upRes = await uploadImgFile('/common/UploadFile', formData).catch(() => {});
						let obj = {
							data_set_uuid: this.addBody.uuid,
							file_item: [{
								file_url: upRes.data.result,
								file_name: file.name,
								file_type: file.name.split('.')[1]
							}]
						}
						const {
							status,
							data
						} = await addTableDataSetFile(obj)
						this.network().getDataSetFile(this.addBody.uuid)
					},
					getDataSetDetail: async () => {
						const {
							status,
							data
						} = await getDataSetDetail({
							uuid: this.addBody.uuid
						})
						this.addBody = data.result
						this.yuliaos = JSON.parse(data.result.yuliao)
					},
					getDataSetFile: async (data_set_uuid) => {
						const {
							status,
							data
						} = await getDataSetFile({
							page_index: 1,
							page_size: 9999,
							data_set_uuid: data_set_uuid
						})
						this.dataSetFiles = data.result.data
					},
					getDataSetYuliao: async (data_set_uuid) => {
						const {
							status,
							data
						} = await getDataSetYuliao({
							page_index: this.page_index1,
							page_size: this.page_size1,
							data_set_uuid: data_set_uuid
						})
						this.yuliaoTables = data.result.data
						this.total1 = data.result.total
					},
					deleteDataSetYuliao: async (uuid) => {
						const {
							status,
							data
						} = await deleteDataSetYuliao({
							id: uuid
						})
						this.$message.success('删除成功')
						this.network().getDataSetYuliao(this.addBody.uuid)
					},
					confirmModuleItem: async (uuid) => {
						const {
							status,
							data
						} = await editTableDataSetYuliao({
							id: this.currentItem.id,
							title: this.title
						})
						this.$message.success('编辑成功')
						this.network().getDataSetYuliao(this.addBody.uuid)
						this.title = ''
						this.currentItem = ''
						this.dialogShow = false
					},
					wordNextClick: async (response, file, fileList) => {
						if (this.file_item.file_tag == 1 && this.data_type_show == 0) {
							return this.$message.error('请选择清洗类型')
						}
						if (this.file_item.file_tag == 1 && this.data_type_show == 2 && this.file_item.data_type_item
							.length == 0) {
							return this.$message.error('请选择分类标识')
						}
						this.file_item.excel_item = this.excel_item
						this.addBody.file_item.push(this.file_item)
						let arr = []
						arr.push(this.file_item)
						let objParams = {
							file_item: arr,
							data_set_uuid: this.addBody.uuid
						}
						if (this.addBody.uuid) {
							const {
								status,
								data
							} = await addDataSetFile(objParams)
							this.dialogVisible = false
							this.fileList=[]
							this.excelList=[]
							this.excelDatas=[]
							this.page_index=1
							this.page_size=10
							this.tableUUID=''
							this.excelTableDatas=''
							this.tableData=[]
							this.nextNum = 1
							this.file_item.excel_item = []
							this.addBody.file_item = []
							this.excel_item.form_uuid=''
							this.excel_item.title_num=''
							this.excel_item.data_num=''
							this.total=0
							this.data_type_show=0
							this.total1=0
							this.page_index1=1
							this.$message.success('添加成功')
							this.network().getDataSetFile(this.addBody.uuid)
							this.network().getDataSetYuliao(this.addBody.uuid)
						}
					},
					addDataSetExcel: async (file) => {
						const formData = new FormData();
						formData.append("file", file);
						const {
							status,
							data
						} = await addDataSetExcel(formData)
						if (status !== 200) return
						this.excelList.push({
							name: file.name,
							size: file.size
						})

						this.file_item.file_name = file.name
						this.file_item.file_type = file.name.split('.')[1]

						this.tableUUID = data.result.master_uuid
						this.network().getDataSetExcelInfo(data.result.master_uuid)
					},
					excelNextConfirm: async () => {
						this.file_item.excel_item = this.excel_item
						this.addBody.file_item.push(this.file_item)
						if (this.addBody.uuid) {
							const {
								status,
								data
							} = await updateCmsDataSet(this.addBody)
							this.$message.success('修改成功')
							this.$router.go(-1)
						} else {
							const {
								status,
								data
							} = await addCmsDataSet(this.addBody)
							if (data.result) {
								this.$message.success('添加成功')
								this.$router.go(-1)
							}
						}
					},
					getDataSetExcelInfo: async (uuid) => {
						const {
							status,
							data
						} = await getDataSetExcelInfo({
							'uuid': uuid
						})
						if (status !== 200) return
						this.excelDatas = data.result
					},
					viewExcelData: async () => {
						const {
							status,
							data
						} = await getDataSetExcel({
							$uid: this.tableUUID,
							'uuid': this.excel_item.form_uuid,
							title_num: this.excel_item.title_num,
							data_num: this.excel_item.data_num,
							page_index: this.page_index,
							page_size: this.page_size
						})
						if (status !== 200) return
						this.excelTableDatas = data.result
						this.tableData = this.excelTableDatas.data.map(item => {
							return item.reduce((acc, curr, idx) => {
								acc[this.excelTableDatas.title[idx]] = curr;
								return acc;
							}, {});
						});
						this.total = data.result.total
					},
				}
			},
		},
	}
</script>

<style lang="less" scoped>
	.dankal-image-upload {
		.add-box {
			display: flex;
			justify-content: space-around;
			align-items: center;
			width: 120px;
			height: 30px;
			border: 1px solid #e5e5e5;
			border-radius: 6px;
			cursor: pointer;
		}
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}


	.tabd {
		width: 120px;
		height: 42px;
		background: #2563EB;
		border-radius: 4px 4px 4px 4px;
		font-family: Roboto, Roboto;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
	}

	.subtitle {
		margin-top: 24px;
		font-family: Roboto, Roboto;
		font-weight: 500;
		font-size: 14px;
		color: #374151;
		margin-bottom: 8px;
	}

	.tab {
		width: 122px;
		height: 42px;
		background: rgba(0, 0, 0, 0);
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #D1D5DB;
		font-family: Roboto, Roboto;
		font-weight: 400;
		font-size: 16px;
		color: #374151;
	}

	.tabd,
	.tab {
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.tabs {
		display: flex;
		align-items: center;
		margin-top: 8px;
	}

	.box-card {
		margin-top: 16px;
	}

	.btnsc {
		width: 120px;
		height: 40px;
		background: #2563EB;
		border-radius: 4px 4px 4px 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: Roboto, Roboto;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
	}

	.clearfix {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.clearfix1 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
	}

	.tabtitles {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.titles {
		flex: 1;
	}

	.t-c {
		text-align: center;
	}

	.t-r {
		text-align: right;
	}

	.t-l {
		text-align: left;
	}

	.ft {
		font-size: 14px;
		color: #000;
	}

	.dankal-image-upload {
		.add-box {
			display: flex;
			justify-content: space-around;
			align-items: center;
			width: 120px;
			height: 30px;
			border: 1px solid #e5e5e5;
			border-radius: 6px;
			cursor: pointer;
		}
	}

	.linebg {
		line-height: 50px;
	}

	.title {
		color: #999;
	}
</style>